import {createSlice} from '@reduxjs/toolkit';
import {IOnlineChatState} from 'modules/online-chat/types';
import {createLoadingActions} from 'plugins/loading/actions';
import {withLoadingState} from 'plugins/loading/state';

export const onlineChatModuleName = 'online-chat';

const initialState: IOnlineChatState = withLoadingState({
    isLoading: true,
});

export const onlineChatSlice = createSlice({
    initialState,
    name: onlineChatModuleName,
    reducers: {
        ...createLoadingActions<IOnlineChatState>(),
    },
});

export const {
    actions: {actionSetIsLoading: actionSetIsOnlineChatLoading},
    reducer: onlineChatReducer,
} = onlineChatSlice;
